import {LayerCode} from "../../../app/shared/enum/layer-code.enum";

export enum UserRoles {

  APP_EDITOR = 'DG_RBT_GS-AGS_IMMOBILIEN_EDITOR',

  IMMO_PREFIX = 'DG_RBT_GS-AGS_IMMOBILIEN',
  EDITOR_POSTFIX = '_EDITOR',
  VIEWER_POSTFIX = '_view'
}

export class LayerPermission {
  createFeatureRoles: Array<UserRoles> = [];
  editFeatureRoles: Array<UserRoles> = [];
  deleteFeatureRoles: Array<UserRoles> = [];
  linkProject: Array<UserRoles> = [];
  unlinkProject: Array<UserRoles> = [];
}

export class RoleSettings {
  static layerRoles = [
    {fkLayer: LayerCode.f_verkaufsobjekte, roleSettings: RoleSettings.f_verkaufsobjekte()}
  ];

  private static f_verkaufsobjekte() {
    const verkaufsobjekte = new LayerPermission();
    verkaufsobjekte.createFeatureRoles.push(
      UserRoles.APP_EDITOR
    );

    verkaufsobjekte.deleteFeatureRoles.push(
      UserRoles.APP_EDITOR
    );

    verkaufsobjekte.editFeatureRoles.push(
      UserRoles.APP_EDITOR
    );

    return verkaufsobjekte;
  }
}
